import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useLoadingContext } from "provider/LoadingProvider";
import { useState } from "react";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";

type Props = {
    visible: boolean;
    onHide: () => void;
    documentoVersao: DocumentoVersao | null;
    onConfirm: () => void;
}

const documentoVersaoService = new DocumentoVersaoService();

export default function ModalDocumentoVersaoAlterarValidade(props: Props) {
    const { msgAlerta, msgErro, msgSucesso } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [novaValidade, setNovaValidade] = useState<Date | null>(props.documentoVersao?.validade || null);

    const handleAlterarValidade = () => {
        startLoading();
        documentoVersaoService.alterarValidade(props.documentoVersao?.id || 0, novaValidade).then(() => {
            stopLoading();
            msgSucesso("Alterar Validade", "Validade alterada com sucesso");
            props.onConfirm();
        }).catch((error) => {
            stopLoading();
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Alterar Validade", error.data.message);
            }
        });
    }

    return (
        <>
            <Dialog
                header="Alterar validade"
                visible={props.visible}
                baseZIndex={100}
                style={{ width: '80%' }}
                onHide={props.onHide}
                footer={<>
                    <Button label="Alterar validade" icon="pi pi-check" onClick={handleAlterarValidade} />
                    <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                </>}
            >
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                    <Label className="col col-sm-12" >Nova validade</Label>
                    <DatePicker
                        slotProps={{
                            popper: {
                                disablePortal: true,
                            },
                        }}
                        value={dayjs(novaValidade)}
                        onChange={value => {
                            setNovaValidade(value?.startOf("day").toDate() || null)
                        }}
                    />
                </div>

            </Dialog>
        </>
    );
}